import script from "./UseOfFunds.vue?vue&type=script&setup=true&lang=ts"
export * from "./UseOfFunds.vue?vue&type=script&setup=true&lang=ts"

import "./UseOfFunds.vue?vue&type=style&index=0&id=480e800d&lang=scss"

const __exports__ = script;

export default __exports__